import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { priceFormatter } from "@/lib/utils";
import { Button, Icon, IconV2, Tag, Typography } from "@bookips/sds";
import { useRouter } from "next/router";
export const SPLIT_STRING = "$";
/**
 * 메인 상품 금액 표기 — 카드와 스와이퍼 칩이 공유한다.
 *
 * 두 곳에 같은 식을 따로 두었더니 칩에만 '월 ' 접두가 빠져 같은 상품이 다르게 보였다.
 * 표기가 갈라지지 않도록 여기 한 곳에서만 만든다.
 *
 * - 체험 미적용 월 단위 상품만 '월 9,900원'처럼 단위를 앞에 붙인다
 * - 체험 시 0원은 displayPrice 가 담고 있다(BE 계약). ?? 로 0 보존 (|| 금지)
 */ export const formatMainProductPrice = (pass)=>{
    const showMonthlyUnit = (pass.subscription == null || pass.subscription.trialEnabled === false) && pass.priceUnit === "month";
    var _pass_displayPrice;
    return "".concat(showMonthlyUnit ? "월 " : "").concat(priceFormatter((_pass_displayPrice = pass.displayPrice) !== null && _pass_displayPrice !== void 0 ? _pass_displayPrice : pass.price), "원");
};
const AnnualPassCard = (props)=>{
    var _props_mainInfo;
    const router = useRouter();
    const { id , badgeTitle , title , noticeInfo , discountRate , price , originPrice , ctaUrl , tagTitle , subTitle , displayPrice , subPriceText , subscription , tabName  } = props;
    // 한 구획에 월구독·일반 카드가 섞여 오므로 카드가 스스로 판정한다 (subscription은 월구독에만 채워짐)
    const isSubscription = subscription != null;
    const isBest = props.type === "best";
    var _props_mainInfo_split;
    // 월구독 아이템은 mainInfo 미포함일 수 있어 방어 (BE 필수 필드 채움 여부 확인 전까지)
    const mainInfo = (_props_mainInfo_split = (_props_mainInfo = props.mainInfo) === null || _props_mainInfo === void 0 ? void 0 : _props_mainInfo.split(SPLIT_STRING)) !== null && _props_mainInfo_split !== void 0 ? _props_mainInfo_split : [];
    return(// 모바일 스와이퍼: w-full / 데스크탑 그리드(>=744px, isMobile 기준): gap-3 × 2 기준 한 줄 최대 3개
    /*#__PURE__*/ _jsxs("div", {
        className: "relative flex shrink-0 flex-col gap-5 rounded-lg border border-gray-100 bg-white px-5 py-6 min-[744px]:w-auto min-[744px]:grow min-[744px]:basis-[calc((100%-24px)/3)]",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col gap-2 max-sm:hidden",
                children: [
                    (badgeTitle || tagTitle) && /*#__PURE__*/ _jsxs("div", {
                        className: "flex gap-1",
                        children: [
                            badgeTitle && /*#__PURE__*/ _jsx(Tag, {
                                accent: true,
                                color: "red",
                                size: "sm",
                                bold: true,
                                children: badgeTitle
                            }),
                            tagTitle && /*#__PURE__*/ _jsx(Tag, {
                                color: "gray",
                                size: "sm",
                                bold: true,
                                children: tagTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h6",
                        className: "break-keep text-gray-900",
                        children: title
                    }),
                    isSubscription && subTitle && /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-secondary",
                        children: subTitle
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-1 flex-col",
                children: /*#__PURE__*/ _jsxs("ul", {
                    className: "flex flex-col gap-2",
                    children: [
                        mainInfo.map((info)=>/*#__PURE__*/ _jsxs("li", {
                                className: "flex gap-1.5",
                                children: [
                                    /*#__PURE__*/ _jsx(Icon.Check_2px, {
                                        className: "text-primary-main mt-0.5 size-4 shrink-0"
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subtitle2",
                                        children: info
                                    })
                                ]
                            }, info)),
                        (noticeInfo || props.subInfo) && /*#__PURE__*/ _jsxs("li", {
                            role: "button",
                            onClick: ()=>{
                                if (props.handleClick) {
                                    props.handleClick({
                                        subInfo: props.subInfo,
                                        noticeInfo
                                    });
                                }
                                //mx-02 유의사항 보기 클릭
                                mixpanelEvent("Product Detail Button Clicked", {
                                    "Product Categories": "main product",
                                    "Button UI": "text"
                                });
                            },
                            className: "flex cursor-pointer items-center gap-1.5 hover:underline",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "mx-1 size-1 shrink-0 rounded-full bg-gray-500"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "subtitle2",
                                            className: "text-secondary",
                                            children: "상세 내용보기"
                                        }),
                                        /*#__PURE__*/ _jsx(IconV2.ChevronRight, {
                                            thick: true,
                                            tight: true,
                                            className: "text-secondary size-3.5 shrink-0"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-col items-end",
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-1",
                            children: [
                                (subscription === null || subscription === void 0 ? void 0 : subscription.trialEnabled) ? /*#__PURE__*/ _jsx(Typography, {
                                    variant: "h6",
                                    as: "span",
                                    className: "text-red-400",
                                    children: "첫 ".concat(subscription.trialDays, "일 무료")
                                }) : discountRate ? /*#__PURE__*/ _jsxs(Typography, {
                                    variant: "h6",
                                    as: "span",
                                    className: "text-red-400",
                                    children: [
                                        Math.trunc(discountRate),
                                        "%"
                                    ]
                                }) : "",
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "h6",
                                    as: "span",
                                    className: "text-gray-900",
                                    children: formatMainProductPrice(props)
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-wrap justify-end gap-1",
                            children: [
                                originPrice !== price && /*#__PURE__*/ _jsx("s", {
                                    className: "typo-body2 whitespace-nowrap text-gray-300 line-through",
                                    children: "정가 ".concat(originPrice.toLocaleString(), "원")
                                }),
                                subPriceText && /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body2",
                                    className: "text-secondary whitespace-nowrap",
                                    children: subPriceText
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "fill",
                    color: isBest ? "primary" : "secondary",
                    size: "lg",
                    fullWidth: true,
                    onClick: ()=>{
                        // TODO(월구독): 결제 진입 테스트용 임시 경로. 월구독 CTA가 어드민 ctaUrl로
                        // 확정되면 이 분기를 제거하고 ctaUrl 하나만 쓴다.
                        const targetUrl = isSubscription && (subscription === null || subscription === void 0 ? void 0 : subscription.planId) ? "/shop/checkout?id=".concat(subscription.planId, "&orderType=subscription") : ctaUrl;
                        var _subscription_planId, _subscription_trialEnabled;
                        //mx-207 / MX-207 구매하기 버튼 클릭 시
                        mixpanelEvent("Main Product Purchase Button Clicked", {
                            Subject: props.subject,
                            "Product Title": title,
                            url: ctaUrl,
                            Position: "이용권 구매 페이지 상단 메인 모듈",
                            // 실제 이동 경로를 보낸다 — 월구독은 어드민 ctaUrl 이 아니라 planId 결제 경로로 간다
                            "Button URL": targetUrl,
                            // 월구독은 planId 로 결제에 들어가므로 Order Page Viewed 와 조인되도록 결제 대상 id 를 보낸다
                            "Product Id": (_subscription_planId = subscription === null || subscription === void 0 ? void 0 : subscription.planId) !== null && _subscription_planId !== void 0 ? _subscription_planId : id,
                            "Button Name": isSubscription ? "구독하기" : "구매하기",
                            // 구독/단품 이분법으로 찍으면 연 단위 구독이 '월 구독'으로 잘못 나가므로 단위를 그대로 보낸다.
                            // 구독 여부는 Button Name('구독하기' / '구매하기')으로 갈린다
                            "Product Type": props.priceUnit,
                            ...tabName && {
                                "Tab Name": tabName
                            },
                            "Is Free Trial": (_subscription_trialEnabled = subscription === null || subscription === void 0 ? void 0 : subscription.trialEnabled) !== null && _subscription_trialEnabled !== void 0 ? _subscription_trialEnabled : false
                        });
                        router.push(targetUrl);
                    },
                    children: isSubscription ? "구독하기" : "구매하기"
                })
            })
        ]
    }));
};
export default AnnualPassCard;
